import React, { useState, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import "./Login.css";
import { api, setAccessToken } from "../../services/api";
import { useAuthStore } from "../../services/useAuthStore";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const visualSectionRef = useRef(null);

  const setAuthFromLogin = useAuthStore((s) => s.setAuthFromLogin);
  const switchWorkspace = useAuthStore((s) => s.switchWorkspace);

  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      // Login apenas com email e senha (sem workspace)
      const response = await api.post("/api/auth/login", {
        email,
        password,
      });

      const token = response.data.access_token;
      setAccessToken(token);

      // Definir auth do login
      setAuthFromLogin(response.data);

      const workspaces = response.data.workspaces || [];

      if (workspaces.length === 1) {
        // Usuario com apenas 1 workspace: ir direto para o app
        await switchWorkspace(workspaces[0].id);
        const from = location.state?.from?.pathname || "/";
        navigate(from, { replace: true });
      } else if (workspaces.length > 1) {
        // Usuario com multiplos workspaces: mostrar seletor
        navigate("/select-workspace", { replace: true });
      } else {
        // Usuario sem workspaces (edge case)
        setError("Nenhum workspace disponivel para esta conta.");
      }

    } catch (err) {
      let errorMessage =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.response?.data?.detail;

      if (!errorMessage && err.response?.status === 401) {
        errorMessage = "Email ou senha incorretos.";
      }

      setError(errorMessage || "Erro de conexao com o servidor.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleMouseMove = (e) => {
    if (!visualSectionRef.current) return;
    const { left, top, width, height } = visualSectionRef.current.getBoundingClientRect();
    const x = (e.clientX - left) / width;
    const y = (e.clientY - top) / height;

    visualSectionRef.current.style.setProperty("--mouse-x", x);
    visualSectionRef.current.style.setProperty("--mouse-y", y);
  };

  return (
    <div className="login-page">
      <div className="login-split-screen">

        <div
          className="login-visual-section"
          ref={visualSectionRef}
          onMouseMove={handleMouseMove}
        >

          <div className="tech-background base-layer">
            <div className="tech-grid"></div>
            <div className="tech-glow"></div>
          </div>


          <div className="tech-background reveal-layer">
            <div className="tech-grid active"></div>
            <div className="tech-glow active"></div>
          </div>

          <div className="login-image-content">
            <h2>Potencialize sua equipe</h2>
            <p>A plataforma completa para gerenciar e escalar suas operacoes com inteligencia e rapidez.</p>
          </div>
        </div>


        <div className="login-form-section">
          <div className="login-container">
            <div className="login-header">
              <img src="/logoFastTeamGreen.png" alt="FastTeam Logo" className="login-logo" style={{ height: "40px" }} />
              <h2 className="login-title">Bem-vindo de volta</h2>
              <p className="login-subtitle">
                Acesse sua conta e gerencie suas automacoes.
              </p>
            </div>

            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">E-mail</label>
                <input
                  id="email"
                  type="email"
                  className="form-control"
                  placeholder="voce@empresa.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Senha</label>
                <div className="password-input-wrapper">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="********"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex="-1"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              {error && <div className="login-error">{error}</div>}

              <button
                type="submit"
                className="btn-login"
                disabled={isLoading}
              >
                {isLoading ? "Entrando..." : "Entrar"}
              </button>

              <Link to="/register" className="btn-link-inline">
                Nao tem uma conta? Cadastre-se
              </Link>
            </form>

            <div className="login-footer">
              <p>&copy; 2025 Fasteam. All rights reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
